/** 与 intl AddModal 创单表单一致 */
export const INTL_CALLBACK_URL_PATTERN =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?%#[\]@!$&'()*+,;=.]+$/;

const INTL_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** 国际创单/详情编辑共用的联系方式与回调校验 */
export function validateIntlContactFields(fields = {}) {
  const callbackUrl = (fields.callback_url ?? "").trim();
  const appEmail = (fields.app_email ?? "").trim();
  const remark = (fields.remark ?? "").trim();

  if (!callbackUrl) {
    return { valid: false, message: "请输入回调地址" };
  }
  if (!INTL_CALLBACK_URL_PATTERN.test(callbackUrl)) {
    return { valid: false, message: "请输入http或者https地址" };
  }
  if (!appEmail) {
    return { valid: false, message: "请填写邮箱" };
  }
  if (!INTL_EMAIL_PATTERN.test(appEmail)) {
    return { valid: false, message: "邮箱格式不正确" };
  }
  if (remark.length > 100) {
    return { valid: false, message: "备注不超过100个字符" };
  }

  return { valid: true };
}

/**
 * 创单后从 lists 解析软件 id（禁止 app_name 反查）
 */
export function resolveSoftwareIdAfterCreate(lists, createContext = {}) {
  const list = Array.isArray(lists?.list) ? lists.list : [];
  if (!list.length) {
    return null;
  }

  const { channel, app_cate_id: appCateId } = createContext;

  let candidates = list.filter((item) => {
    if (channel !== undefined && Number(item.channel) !== Number(channel)) {
      return false;
    }
    if (
      appCateId !== undefined &&
      Number(item.app_cate_d ?? item.app_cate_id) !== Number(appCateId)
    ) {
      return false;
    }
    return true;
  });

  if (!candidates.length) {
    candidates = [...list];
  }

  candidates.sort((a, b) => {
    const timeA = Date.parse(a.ctime || "") || 0;
    const timeB = Date.parse(b.ctime || "") || 0;
    return timeB - timeA;
  });

  if (candidates.length === 1) {
    return candidates[0].id ?? null;
  }

  const [latest, second] = candidates;
  if (!latest?.id) {
    return null;
  }

  const latestTime = Date.parse(latest.ctime || "") || 0;
  const secondTime = Date.parse(second?.ctime || "") || 0;
  if (latestTime > secondTime) {
    const sameBucket = candidates.filter(
      (item) => item.ctime === latest.ctime && Number(item.channel) === Number(latest.channel)
    );
    if (sameBucket.length === 1) {
      return latest.id;
    }
  }

  return null;
}

export function buildIntlCreatePayload(values = {}) {
  return {
    app_name: values.app_name,
    channel: values.channel,
    callback_url: values.callback_url,
    app_cate_id: values.app_cate_id,
    app_email: values.app_email,
    contact_x: values.contact_x,
    contact_telegram: values.contact_telegram,
    contact_discord: values.contact_discord,
    remark: values.remark,
  };
}

export function getIntlRejectReason(item = {}) {
  if (Number(item.app_status_id) !== 3) {
    return null;
  }

  const reason = String(item.offline_reason ?? "").trim();
  return reason && reason !== "-" ? reason : "--";
}
